import React from 'react';
import RegistrationForm from '../../components/registration/RegistrationForm';
import WelcomeText from "../../components/registration/welcome-text/WelcomeText";
import "./Registration.scss";
import {LargerThanMobile} from "../../components/responsive/responsive";

const Registration = (props) => (
      <div className="hrb-registration-page">
        <LargerThanMobile>
          <div className="hrb-registration-page-welcome-text">
            <WelcomeText title="registration.welcome_text" subTitle="registration.welcome_sub_text"/>
          </div>
        </LargerThanMobile>
        <RegistrationForm {...props} />
      </div>
);

export default Registration;